import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utilitaire pour fusionner les classes Tailwind CSS.
 * 
 * Combine clsx (classes conditionnelles) et tailwind-merge (résolution des conflits).
 * 
 * @example
 * cn("px-2 py-1", "p-4") // => "p-4" (p-4 gagne sur px-2 py-1)
 * cn("text-red-500", condition && "text-blue-500") // => conditionnel
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
